import { Dispatch } from 'redux';

import { TradeSocketResponse } from 'src/types';

import { socketSlice } from './socketSlice';

const { actions } = socketSlice;
export const updateTradeData =
    (responseMsg: TradeSocketResponse, tradeType: string) => (dispatch: Dispatch) => {
        dispatch(actions.updateTradeData({ data: responseMsg, tradeType }));
    };
export const resetTradeData = () => (dispatch: Dispatch) => {
    dispatch(actions.resetTradeData());
};
export const clearKlineData = (type: string) => (dispatch: Dispatch) => {
    dispatch(actions.clearKlineData(type));
};
